var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dsafsa"},[_c('div',{key:_vm.echarkey,ref:"main",staticStyle:{"width":"1600px","height":"400px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }